var map = {
	"./codigo-qr-contato-onesti.png": "a473",
	"./footer-links/fundo-anticorrupcao.jpg": "dec5",
	"./footer-links/fundo-escravidao-moderna.jpg": "8285",
	"./footer-links/fundo-politica-geral.jpg": "a930",
	"./footer-links/fundo-politica-verde.jpg": "6e0f",
	"./footer-links/honestidade.svg": "8e5e",
	"./footer-links/juntos-somos-mais-fortes.svg": "0855",
	"./footer-links/maos-acorrentadas.jpg": "8243",
	"./footer-links/mulher-sinal-silencio.jpg": "e9e3",
	"./footer-links/reduza-reuse-recicle-respeite.svg": "a345",
	"./footer-links/tronco-cortado.png": "3a68",
	"./icone-coracao-rosa.svg": "2d6c",
	"./icone-coracao.svg": "f8f6",
	"./icons/bulb.svg": "8fad",
	"./icons/chevron-left-solid-white.svg": "959d",
	"./icons/chevron-left-solid.svg": "7c9e",
	"./icons/chevron-right-solid-white.svg": "56c3",
	"./icons/chevron-right-solid.svg": "f5fd",
	"./icons/floater.svg": "76f5",
	"./icons/hammer.svg": "84ab",
	"./icons/rocket.svg": "df02",
	"./icons/stopwatch.svg": "ea88",
	"./logos-cases/logo-alianza.jpg": "a9d6",
	"./logos-cases/logo-ampara-animal.jpg": "f287",
	"./logos-cases/logo-batista-agronegocio.jpg": "1128",
	"./logos-cases/logo-bibi.jpg": "16e7",
	"./logos-cases/logo-buu.jpg": "7a6e",
	"./logos-cases/logo-crown.jpg": "8de7",
	"./logos-cases/logo-encompass-brasil.jpg": "91b9",
	"./logos-cases/logo-estre.jpg": "3364",
	"./logos-cases/logo-estudio-diogo-portugal.jpg": "c274",
	"./logos-cases/logo-fagundes.jpg": "7870",
	"./logos-cases/logo-fitpay.jpg": "4fc1",
	"./logos-cases/logo-le-postiche.jpg": "09c3",
	"./logos-cases/logo-lupema.jpg": "5474",
	"./logos-cases/logo-nathan.jpg": "4207",
	"./logos-cases/logo-servdigital.jpg": "5fe3",
	"./logos-cases/logo-tesla.png": "ee27",
	"./logos-cases/logo-today.jpg": "fd10",
	"./logos-cases/logo-troianos.jpg": "f5e4",
	"./logos-cases/logo-tutu-digital.jpg": "d2ad",
	"./logos/abc-color.svg": "61fc",
	"./logos/bloomberg.svg": "6ce5",
	"./logos/canal-futura.svg": "5dc9",
	"./logos/estadao.svg": "60b8",
	"./logos/exame.svg": "810b",
	"./logos/globo.svg": "50fb",
	"./logos/istoe-dinheiro.svg": "a6c8",
	"./logos/istoe.svg": "1f91",
	"./logos/la-nacion.svg": "0fb6",
	"./logos/lide.svg": "1d5b",
	"./logos/o-povo.svg": "9816",
	"./logos/rn-record-news.jpg": "63ef",
	"./logos/voce-sa.svg": "1c2f",
	"./logos/whatsapp.png": "8101",
	"./onesti-logo/a-pattern.svg": "a77d",
	"./onesti-logo/a-symbol-gray.svg": "ca1a",
	"./onesti-logo/a-symbol-white.svg": "ed36",
	"./onesti-logo/a-symbol.svg": "5294",
	"./onesti-logo/dvogados-cn.svg": "0a13",
	"./onesti-logo/dvogados-en.svg": "9ebb",
	"./onesti-logo/dvogados-es.svg": "6705",
	"./onesti-logo/dvogados-pt.svg": "0006",
	"./onesti-logo/onesti-logo-branco-cn.svg": "8525",
	"./onesti-logo/onesti-logo-branco-en.svg": "efe8",
	"./onesti-logo/onesti-logo-branco-es.svg": "76bc",
	"./onesti-logo/onesti-logo-branco-pt.svg": "d4cf",
	"./onesti-logo/onesti-logo-cn.svg": "ee5f",
	"./onesti-logo/onesti-logo-en.svg": "bb7c",
	"./onesti-logo/onesti-logo-es.svg": "cec9",
	"./onesti-logo/onesti-logo-pt.svg": "a353",
	"./onesti-logo/onesti.svg": "8cf6",
	"./partners-logos/logo-arrais.png": "ff83",
	"./partners-logos/logo-buu.png": "0230",
	"./partners-logos/logo-guiudo.png": "42c4",
	"./partners-logos/logo-lelukas.svg": "21d2",
	"./partners-logos/logo-lingchao.png": "9408",
	"./partners-logos/logo-valle.png": "8655",
	"./partners-logos/logo-yusef.png": "23b2",
	"./screenshots/abc-color-site.jpg": "c3f8",
	"./screenshots/bloomberg-site.jpg": "4ab3",
	"./screenshots/canal-futura-site.jpg": "1496",
	"./screenshots/estadao-jornal.jpg": "7eb1",
	"./screenshots/exame-site.jpg": "650a",
	"./screenshots/g1-site.jpg": "57fb",
	"./screenshots/istoe-dinheiro-site.jpg": "c73a",
	"./screenshots/istoe-site.jpg": "ce84",
	"./screenshots/la-nacion-site.jpg": "6b61",
	"./screenshots/meeting-revista.jpg": "9290",
	"./screenshots/o-povo-site.jpg": "987c",
	"./screenshots/record-news-site.jpg": "e5f5",
	"./screenshots/voce-sa.jpg": "98b3",
	"./sections/dardo-no-centro-de-alvo.jpg": "ac4e",
	"./sections/inovacao-logo-cn.svg": "9aca",
	"./sections/inovacao-logo-en.svg": "4e13",
	"./sections/inovacao-logo-es.svg": "f012",
	"./sections/inovacao-logo-pt.svg": "254c",
	"./sections/mao-impedindo-blocos-de-derrubarem-outros-blocos.jpg": "1936",
	"./sections/microfone-em-fundo-desfocado.jpg": "89b2",
	"./sections/montando-blocos.jpg": "51db",
	"./sections/mulher-segurando-origami-de-coelho.jpg": "f1a5",
	"./sections/peca-xadrez-movida-estrategia.jpg": "f777",
	"./sections/pessoa-montando-blocos.jpg": "a53e",
	"./sections/pessoas-cooperando.jpg": "4fdc",
	"./sections/pessoas-juntando-maos-cooperacao.jpg": "e4af",
	"./sections/pessoas-trabalhando-usando-tablet.jpg": "a644",
	"./sections/section-divider-black.svg": "235b",
	"./sections/section-divider.svg": "482c",
	"./sections/smartphone-em-praia-direcionamento.jpg": "614a",
	"./sections/varios-origamis-dentro-de-recipiente.jpg": "5f73",
	"./sections/varios-passaros-origami-alinhados.jpg": "d469",
	"./testimony/foto-bruno-fagundes.jpg": "6b14",
	"./testimony/foto-carlos-martin.jpeg": "a160",
	"./testimony/foto-celso-cavallini.jpg": "699e",
	"./testimony/foto-christian-do-valle.jpg": "0048",
	"./testimony/foto-flavio-baiocchi.jpg": "9864",
	"./testimony/foto-henrique-ravanelli.jpg": "534e",
	"./testimony/foto-joelma-dvoranovski.jpg": "58fa",
	"./testimony/foto-jose-renato-mannis.jpg": "d88b",
	"./testimony/foto-juliana-camargo.jpg": "50bc",
	"./testimony/foto-oscar-martins.jpeg": "e4aa",
	"./vista-rua-com-predios@large.jpg": "792f",
	"./vista-rua-com-predios@medium.jpg": "bdb9",
	"./vista-rua-com-predios@small.jpg": "924f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";